import GoogleMapReact from "google-map-react";

const Marker = ({ lat, lng, text }) => (
  <div className="absolute cursor-pointer z-50" style={{ transform: 'translate(-50%, -100%)' }}>
    {/* SVG Marker */}
    <svg
      width="45"
      height="30"
      viewBox="0 0 45 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-md" aria-hidden={true} focusable="false">
      <ellipse
        opacity="0.3"
        cx="22.4903"
        cy="24"
        rx="22.4747"
        ry="6"
        fill="#EB5A3C"
      />
      <path
        d="M32.4176 10C32.4176 17 23.0096 23 23.0096 23C23.0096 23 13.6016 17 13.6016 10C13.6016 7.61305 14.5928 5.32387 16.3571 3.63604C18.1214 1.94821 20.5144 1 23.0096 1C25.5047 1 27.8977 1.94821 29.662 3.63604C31.4264 5.32387 32.4176 7.61305 32.4176 10Z"
        stroke="#EB5A3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.011 13C24.743 13 26.147 11.6569 26.147 10C26.147 8.34315 24.743 7 23.011 7C21.279 7 19.875 8.34315 19.875 10C19.875 11.6569 21.279 13 23.011 13Z"
        stroke="#EB5A3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

const GoogleMap = ({ coordinates, height, marker = false }) => {
  const renderMarker = (map, maps) => {
    new maps.Marker({
      position: {
        lat: coordinates.lat,
        lng: coordinates.lng,
      },
      map,
    });
  }
  return (
    <div style={{ height: height, width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY + "" }}
        defaultCenter={coordinates}
        defaultZoom={9}
        options={{
          disableDefaultUI: true,
        }}
        yesIWantToUseGoogleMapApiInternals={true}
      // uncomment below to show the marker
      // onGoogleApiLoaded={({ map, maps }) => renderMarker(map, maps)} 
      >
        {
          marker && (
            <Marker
              lat={coordinates?.lat}
              lng={coordinates?.lng}
            />
          )
        }
      </GoogleMapReact>

    </div>

  );

};

export default GoogleMap;
